// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationBanner-cls1___817bee68aec755be0c1","cls2":"ConfirmationBanner-cls2___2a3b807c5a0cfaf50fc ConfirmationBanner-cls1___817bee68aec755be0c1"};